var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProfileIcon = function SvgProfileIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 19,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#191308",
    d: "M13.67 18.332h-1.667v-1.667a2.5 2.5 0 0 0-2.5-2.5h-5a2.5 2.5 0 0 0-2.5 2.5v1.667H.336v-1.667A4.167 4.167 0 0 1 4.503 12.5h5a4.167 4.167 0 0 1 4.166 4.166zm-6.667-7.5a5 5 0 1 1 0-10 5 5 0 0 1 0 10m0-1.667a3.333 3.333 0 1 0 0-6.666 3.333 3.333 0 0 0 0 6.666"
  })));
};
export default SvgProfileIcon;